<template>
  <div id="sac-dropdown-container">
    <button
      tabindex="0"
      type="button"
      :class="[lcSelectedPlanIds.length > 0 ? 'active' : '', 'dropdown-filters']"
      @focusout="toggleShow(false)"
      @click="toggleShow(!show)"
    >
      Active filters
      <span class="sac-arrow-container">
        <svg viewBox="0 0 24 24" :class="['arrow-down', show ? 'active' : '']">
          <path
            :fill="lcSelectedPlanIds.length > 0 ? 'white' : 'black'"
            d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
          />
        </svg>
      </span>
    </button>
    <div
      tabindex="0"
      :class="[
        show ? 'active' : '',
        'sac-option-container',
      ]"
      @focus="toggleShow(true)"
      @focusout="toggleShow(false)"
    >
      <div class="grid-column ai-c jc-b">
       <span>Filters</span>
        <button
          v-if="allCorpPlans.length > 0"
          type="button"
          class="clear-button"
          @mousedown="clearFilters"
        >
          Clear all
        </button>
      </div>
      <div class="margin-top-16">
        <div class="divider-h">
          Plan
        </div>
        <SACCheckbox
          v-for="(option, i) of allCorpPlans"
          :key="i"
          :checked="lcSelectedPlanIds.includes(option.planId)"
          :change="() => toggleCheckbox(option.planId)"
          class="filter-checkbox"
          :label="option.name"
        />
      </div>
      <div class="margin-top-16">
        <div class="divider-h">
          Plan Type
        </div>
        <SACCheckbox
          v-for="(option, i) of planTypeOptions"
          :key="i"
          :checked="lcSelectedPlanTypes.includes(option.value)"
          :change="() => toggleMembershipTypes(option.value)"
          class="filter-checkbox"
          :label="option.label"
        />
      </div>
      <div class="margin-top-16">
        <div class="margin-top-8 divider-h">
          Virtual Visits
        </div>
        <SACCheckbox
          :checked="hasVirtualVisit"
          :change="() => toggleVirtualVisits(true)"
          class="filter-checkbox"
          label="Yes"
        />
        <SACCheckbox
          :checked="hasVirtualVisit === false"
          :change="() => toggleVirtualVisits(false)"
          class="filter-checkbox"
          label="No"
        />
      </div>
    </div>
  </div>
</template>
<script>
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';
import { mapState } from 'vuex';

export default {
  name: 'PlanFilter',
  components: { SACCheckbox },
  computed: {
    ...mapState({
      allCorpPlans: (state) => state.customerDetail.allCorpPlans,
      hasVirtualVisit: (state) => state.customer.hasVirtualVisit,
    }),
  },
  data() {
    return {
      show: false,
      lcSelectedPlanIds: [],
      lcSelectedPlanTypes: [],
      planTypeOptions: [{
        label: 'Detect',
        value: 'Monitored',
      }, {
        label: 'Connect',
        value: 'AppOnly',
      }]
    };
  },
  watch: {
    selectedCorpId() {
      this.clearFilters();
    },
  },
  methods: {
    clearFilters() {
      this.lcSelectedPlanIds = [];
      this.lcSelectedPlanTypes = [];
      this.$store.dispatch('changeCustomerValue', {
        field: 'selectedPlanIds',
        value: [],
      });
      this.$store.dispatch('changeCustomerValue', {
        field: 'hasVirtualVisit',
        value: null,
      });
      this.toggleShow();
      this.$store.dispatch('getAllCustomers');
    },
    toggleCheckbox(id) {
      this.lcSelectedPlanIds = this.lcSelectedPlanIds.includes(id)
        ? this.lcSelectedPlanIds.filter((el) => el !== id) : [...this.lcSelectedPlanIds, id];
      this.$store.dispatch('changeCustomerValue', {
        field: 'selectedPlanIds',
        value: this.lcSelectedPlanIds,
      });
      this.$store.dispatch('getAllCustomers');
    },
    toggleMembershipTypes(type) {
      this.lcSelectedPlanTypes = this.lcSelectedPlanTypes.includes(type)
        ? this.lcSelectedPlanTypes.filter((el) => el !== type) : [...this.lcSelectedPlanTypes, type];
      this.$store.dispatch('changeCustomerValue', {
        field: 'selectedMembershipTypes',
        value: this.lcSelectedPlanTypes,
      });
      this.$store.dispatch('getAllCustomers');
    },
    toggleVirtualVisits(value) {
      this.$store.dispatch('changeCustomerValue', {
        field: 'hasVirtualVisit',
        value: value,
      });
      this.$store.dispatch('getAllCustomers');
    },
    toggleShow(show) {
      if (!this.disable) {
        this.show = show;
      }
      if (show && this.$refs[`cs-${this.field}-input-search`]) {
        this.$refs[`cs-${this.field}-input-search`].focus();
      }
    },
  },
};
</script>

<style scoped lang="scss">
#sac-dropdown-container {
  max-width: 305px;
  .dropdown-filters {
    background-color: #DBE4FF;
    padding: 10px 15px 10px 15px;
    border-radius: 4px;
    display: flex;
    color: black;
    justify-content: center;
    align-items: center;
  }
  .dropdown-filters.active {
    background-color: $PRIMARY;
    color: white;
  }
  .sac-arrow-container {
    display: flex;
    align-items: center;
    margin-left: 15px;
    grid-column: 2;
  }
  .arrow-down {
    height: 20px;
    width: 20px;
    &.active {
      transition: transform 200ms ease;
      transform: rotate(-180deg);
    }
  }
  .sac-option-container {
    color: $N90;
    border-radius: 8px;
    position: absolute;
    background: $WHITE;
    left: 0;
    right: 0;
    box-shadow: 0 1px 27px 12px rgb(9 15 32 / 10%);
    z-index: 1;
    max-height: 300px;
    width: 300px;
    overflow-y: auto;
    padding: 14px;
    overflow-x: hidden;
    transform: scaleY(0);
    transform-origin: top;
    transition: transform 200ms ease;

    &.active {
      transform: scaleY(1);
    }
    span {
      font-size: 14px;
      font-weight: 600;
    }
    .clear-button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: $NBLUE100;
      text-decoration: underline;
      border-radius: 8px;
      padding: 0px 16px;
      font-weight: 600;
      &:hover {
        transition: all 280ms ease-in-out;
      }
    }
  }
}
</style>
